import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
          准备好开始您的六角琴之旅了吗？
        </h2>
        <p className="mt-3 md:mt-4 text-sm md:text-base text-background-50/80 max-w-xl mx-auto">
          无论您是初学者还是专业演奏者，琴韵阁都能为您提供最适合的学习资源和选购建议。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/category/ru-men-jiao-cheng"
            className="inline-flex items-center gap-2 bg-background-50 text-primary-600 px-6 py-3 rounded-md font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
            入门教程
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-primary-600 text-background-50 px-6 py-3 rounded-md font-medium text-sm hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line w-4 h-4 flex items-center justify-center"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}